<div
  class="select-container"
>
  @for (option of selectOptions(); track option.value) {
    <div
      class="radio-item body2"
      [routerLink]="option.link"
      routerLinkActive="selected"
    >
      <input
        [id]="option.value"
        [value]="option.value"
        type="radio"
        [attr.name]="radioGroup()"
      />
      <label
        [for]="option.value"
        class="label subtitle1"
      >
        {{ option.labelText }}
      </label>
    </div>
  }
</div>
